import script from "./MetalsList.vue?vue&type=script&setup=true&lang=js"
export * from "./MetalsList.vue?vue&type=script&setup=true&lang=js"

import "./MetalsList.vue?vue&type=style&index=0&id=687cb680&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-687cb680"]])

export default __exports__